/* Shopify port (v5, 2026-10-06): vanilla versions of the preview's three
   client components. Reveal (fade-up on scroll), StickyCtaBar (shown once the
   product section is reached; the desktop bar steps aside while the offer card
   is on screen). Everything else on the page is static HTML and CSS. */
(function () {
  var root = document.querySelector(".jv-lp");
  if (!root || !("IntersectionObserver" in window)) {
    if (root) root.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-visible"); });
    return;
  }
  var rio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-visible"); rio.unobserve(e.target); } });
  }, { threshold: 0, rootMargin: "0px 0px -8% 0px" });
  root.querySelectorAll(".reveal").forEach(function (el) { rio.observe(el); });

  var bars = root.querySelectorAll("[data-jv-bar]");
  var anchor = document.getElementById(root.getAttribute("data-anchor"));
  if (!bars.length || !anchor) return;
  var show = false, offerInView = false, seen = new Set();
  function paint() {
    bars.forEach(function (b) {
      var on = b.getAttribute("data-jv-bar") === "desktop" ? show && !offerInView : show;
      b.classList.toggle("translate-y-0", on);
      b.classList.toggle("translate-y-full", !on);
      b.classList.toggle("pointer-events-none", !on);
      b.setAttribute("aria-hidden", on ? "false" : "true");
      b.querySelectorAll("a").forEach(function (a) { a.tabIndex = on ? 0 : -1; });
    });
  }
  new IntersectionObserver(function (es) {
    var e = es[0]; show = e.isIntersecting || e.boundingClientRect.top < 0; paint();
  }, { rootMargin: "0px 0px -35% 0px" }).observe(anchor);
  var hide = root.querySelectorAll("[data-bar-hide]");
  if (hide.length) {
    var hio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? seen.add(e.target) : seen.delete(e.target); });
      offerInView = seen.size > 0; paint();
    });
    hide.forEach(function (t) { hio.observe(t); });
  }
})();
